import {
  ErrorDisplay as ErrorDisplayRef,
  NotFoundErrorPage as NotFoundErrorPageRef,
  Progress as ProgressRef,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';
import { ErrorDisplay, NotFoundPage, Progress } from './Fallbacks';

/**
 * The app's loading bar, 404 page and extension error panel, in Backstage UI.
 * The names are the app plugin's own, so these replace its core-components
 * defaults instead of competing with them for the same ref.
 *
 * Only what asks the app for these gets them: a page loader, an extension's
 * error boundary, an unmatched route. A plugin that imports `Progress` or
 * `ErrorPanel` from core-components directly still draws MUI.
 */
export const fallbacksModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SwappableComponentBlueprint.make({
      name: 'core-progress',
      params: define =>
        define({ component: ProgressRef, loader: () => Progress }),
    }),
    SwappableComponentBlueprint.make({
      name: 'core-not-found-error-page',
      params: define =>
        define({ component: NotFoundErrorPageRef, loader: () => NotFoundPage }),
    }),
    SwappableComponentBlueprint.make({
      name: 'core-error-display',
      params: define =>
        define({ component: ErrorDisplayRef, loader: () => ErrorDisplay }),
    }),
  ],
});
